'use strict';

/**
 * filterIntegrationTemplates(templates, account) — pure gate deciding which
 * integration templates an account may see on the Integrations → Add page.
 *
 * The Manager offers:
 *   - OAuth providers via the existing popup flow
 *   - typed-credential integrations (achievers, workday) ONLY on the alpha
 *     programme
 *   - nothing whose provider is under the rocket-* internal namespace
 *
 * rocket-api-side enforcement lands later; until then the Manager hides the
 * alpha-gated typed integrations from any account without `account.alpha`.
 * No alpha flag → you don't see them.
 *
 * @param {Array<{provider?: string, strategy?: string}>} templates
 * @param {{alpha?: boolean}|null|undefined} account
 * @returns {Array<object>}
 */

const ALPHA_GATED_TYPED_PROVIDERS = ['achievers', 'workday'];

function filterIntegrationTemplates(templates, account) {
    // Strict boolean: a stray truthy/string flag (`'yes'`, `'true'`) must NOT
    // grant alpha — fails closed. Mirrors can-manage-magic-link.js.
    const alpha = !!(account && account.alpha === true);
    const list = templates || [];

    return list.filter((template) => {
        const provider = template && template.provider;
        if (provider && provider.startsWith('rocket-')) return false;
        if (ALPHA_GATED_TYPED_PROVIDERS.indexOf(provider) !== -1) {
            return alpha;
        }
        return true;
    });
}

// CommonJS export for Mocha unit tests (guarded so it is a no-op inside the
// concatenated Angular bundle, where `filterIntegrationTemplates` is a plain
// global — mirrors the can-manage-magic-link.js / filter-apps.js pattern).
if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = { filterIntegrationTemplates, ALPHA_GATED_TYPED_PROVIDERS };
}
